import * as React from "react";

import { Button, Grid, Table } from "semantic-ui-react";

import { getYesNoOptionEnabledDisplayValue } from "@teamprevent/common/model";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { ApplicationState } from "../../../applicationState";

import { customerDocumentsSelector } from "../selectors";
import { ADMIN_ROLES, Authorize } from "../../../auth";

import { loadCustomerDocuments } from "../actions";

import { Link } from "redux-little-router";

export const All: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const path = useSelector((state: ApplicationState) => state.router.pathname);
    const customerId = useSelector((state: ApplicationState) => state.router.params.customerId);
    const customerDocuments = useSelector(customerDocumentsSelector).sort((a, b) => a.name.localeCompare(b.name));

    React.useEffect(() => {
        dispatch(loadCustomerDocuments({ customerId }));
    }, [customerId, dispatch]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={14}>
                    <h1>Documents</h1>
                </Grid.Column>
                <Grid.Column width={2} textAlign="right">
                    <Authorize roles={[ADMIN_ROLES.SENIOR_ADMINISTRATOR, ADMIN_ROLES.SYSTEM_ADMIN]}>
                        <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                    </Authorize>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Description</Table.HeaderCell>
                                <Table.HeaderCell>Url</Table.HeaderCell>
                                <Table.HeaderCell>Document</Table.HeaderCell>
                                <Table.HeaderCell>Viewable by Manager</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {customerDocuments && customerDocuments.map(customerDocument => (
                                <Table.Row key={customerDocument.id}>
                                    <Table.Cell>
                                        <Link href={`${path}/${customerDocument.id}`}>
                                            {customerDocument.name}
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Link href={`${path}/${customerDocument.id}`}>
                                            {customerDocument.description}
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell className="url">
                                        <a href={customerDocument.url} target="_blank" rel="noopener noreferrer">
                                            {customerDocument.url}
                                        </a>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Link href={`${path}/${customerDocument.id}`}>
                                            {customerDocument.fileName}
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Link href={`${path}/${customerDocument.id}`}>
                                            {getYesNoOptionEnabledDisplayValue(customerDocument.viewableByManager || false)}
                                        </Link>
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
